import styled from "styled-components"

export const Container = styled.main`
  width: 100vw;
  height: 100vh;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("/images/wood.jpg");
`

export const FrontCover = styled.img`
  background-color: white;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
`

export const BackCover = styled.img`
  background-color: white;
  width: 100%;
  height: 100%;
`

export const BookShelf = styled.img`
  width: 70%;
  height: 100%;
  position: absolute;

  height: 63px;
  margin-top: 450px;
  padding-right: 40px; // 중앙 절렬을 위함
`

export const SpineTitle = styled.span`
  font-size: 1.2rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell,
    "Open Sans", "Helvetica Neue", sans-serif;
  width: 60%;
 
  background-color: rgba(0,0,0,0.5);
  color: white;
  padding: 10px;
  display: flex;
  justify-content: center;
  border-radius: 0.8rem;
  line-height: 1.5rem;

`

export const PageTitle = styled.h1`
  position: absolute;
  top: 5%;
  left: 20%;
`

export const PageDescription = styled.p`
  position: absolute;
  top: 12%;
  left: 20%;
  font-size: 1.1rem;
`

interface SpineCoverPropTypes {
  backgroundImage?: string
}

export const SpineCover = styled.div<SpineCoverPropTypes>`
width: 100%;
height: 100%;
// background-color: white;
background-image: ${props => props.backgroundImage ? props.backgroundImage : "linear-gradient( 95.2deg, rgba(173,252,234,1) 26.8%, rgba(192,229,246,1) 64% );"}
color: black;
box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px black;
  &:hover {
    background-image: linear-gradient(to right, #434343 0%, black 100%);
   color: white;
  }
`

export const DeepWorkCover = styled.div`
  background-color: black;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const CODECover = styled.div`
  background-color: #80b3ff;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const MoneyCover = styled.div`
  background-color: #ff924a;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SevenDBCover = styled.div`
  background-color: #bdd3b9;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const RedableCover = styled.div`
  background-color: #439877;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NodeJSCover = styled.div`
  background-color: #fd6e8a;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NicoCover = styled.div`
  background-color: #80b3ff;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const BookContentBox = styled.div`
  width: 100%;
  height: 100%;
  color: black;
  backface-visibility: hidden;
  padding: 20px;
`

export const BookTitle = styled.h3`
  
`

export const BookAuthor = styled.span`
  font-size: 13px;
  line-height: 20px;
`

export const BookContent = styled.p`
  font-size: 12px;
  line-height: 30px;
  font-weight: 300;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const OJTubeLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const OJTubeLogo = styled.img`
  width: 80%;
`

export const Preparering = styled.div`
  width: 100%;
  height: 100%;
  display: none;
  background-color: black;
  color: white;
  z-index: 1;
  left: 0;
  @media screen and (max-width: 600px) {
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
  }
`

export const BookTechStackList = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.7rem;
`

interface techBoxTypes {
  imageSrc: string;
}

export const TechBox = styled.div<techBoxTypes>`
  box-shadow: 0 0 2px black;
  width: 80px;
  height: 80px;
  border-radius: 10px;
  background-color: white;
  background-image: url(${(props) => props.imageSrc});
  background-size: 80px 80px;
  display: flex;
  color: white;

  font-weight: 700;
`;

export const TechBoxArea = styled.div`
display: grid;
grid-template-columns: 1fr 1fr 1fr 1fr;
align-items: center;
justify-items: center;
grid-gap: 10px;
padding: 10px;


@media screen and (max-width: 1200px) {
  grid-template-columns: 1fr 1fr;
}
`;